import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import css from "./header.module.css";
import OutsideAlerter from "../../utils/OutsideAlerter";
import { UserContext } from "../../context/UserContext";
import logoName from "../../assets/logoName1.png";

export const Header = () => {
  const { user, userLogout, userData } = React.useContext(UserContext);
  const [menuOpen, setMenuOpen] = useState(false); // user menu
  const [navOpen, setNavOpen] = useState(false); // mobile nav
  const menuRef = useRef(null);
  const navRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // close menus on Esc
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
        setNavOpen(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const role = userData?.userType?.category || "user";

  const navItems = [
    { to: "/", label: "Início", show: true },
    { to: "/fieldmap", label: "Formulação", show: true },
    { to: "/metaphors", label: "Metáforas", show: true },
    { to: "/scales", label: "Escalas", show: true },
    // { to: "/courses", label: "Cursos", show: true },
  ];

  // role-specific entries
  if (role === "admin") {
    navItems.push({ to: "/admin", label: "Admin", show: true });
  }

  const displayName = userData?.displayName || user?.displayName || "Usuário";
  const initials = displayName
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header className={css.header}>
      <div className={css.inner}>
        <div className={css.left}>
          <Link to="/" className={css.brand} aria-label="Ibhava — Home">
            <img src={logoName} alt="" />
          </Link>
        </div>

        <nav className={css.navDesktop} aria-label="Navegação principal">
          {navItems.map((item) =>
            item.show ? (
              <Link
                key={item.to}
                to={item.to}
                className={pathname === item.to ? css.activeLink : css.navLink}
              >
                {item.label}
              </Link>
            ) : null
          )}
        </nav>

        <div className={css.right}>
          {/* mobile hamburger */}
          <button
            className={css.hamburger}
            aria-label={navOpen ? "Fechar menu" : "Abrir menu"}
            onClick={() => setNavOpen((v) => !v)}
          >
            <span className="material-icons" aria-hidden>
              menu
            </span>
          </button>

          {/* mobile nav overlay */}
          {navOpen && (
            <div
              className={css.mobileNav}
              role="dialog"
              aria-modal="true"
              ref={navRef}
            >
              <div className={css.mobileNavInner}>
                <button
                  className={css.closeMobile}
                  onClick={() => setNavOpen(false)}
                  aria-label="Fechar"
                >
                  <span className="material-icons">close</span>
                </button>
                <div className={css.mobileLinks}>
                  {navItems.map((n) => (
                    <Link
                      key={n.to}
                      to={n.to}
                      onClick={() => setNavOpen(false)}
                      className={css.mobileLink}
                    >
                      {n.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* quick icons */}

          <OutsideAlerter setMenuButton={setMenuOpen}>
            <div className={css.userWrap}>
              <button
                aria-haspopup="true"
                aria-expanded={menuOpen}
                className={css.userBtn}
                onClick={() => setMenuOpen((s) => !s)}
              >
                {userData?.photoURL ? (
                  <img
                    src={userData.photoURL}
                    alt={displayName}
                    className={css.avatar}
                  />
                ) : (
                  <div className={css.avatarPlaceholder}>{initials}</div>
                )}
                <span className={css.userShort}>
                  {displayName.split(" ")[0]}
                </span>
                <span className="material-icons" aria-hidden>
                  expand_more
                </span>
              </button>

              {menuOpen && (
                <div className={css.userMenu} role="menu" ref={menuRef}>
                  <Link
                    to="/account"
                    onClick={() => setMenuOpen(false)}
                    className={css.userMenuItem}
                  >
                    Conta
                  </Link>
                  <button onClick={userLogout} className={css.userMenuItem}>
                    Sair
                  </button>
                </div>
              )}
            </div>
          </OutsideAlerter>
        </div>
      </div>
    </header>
  );
};
